import * as scheduletypes from '../../constants/ScheduleActionTypes';
import * as types from '../../constants/canvas/ToplistsActionTypes';
import {env} from '../../constants/Environment';

const moment = require('moment')

export function fetch_schedule(firestore, channel, scheduleId, start, end) {
	return function(dispatch){
		dispatch(request_schedule(scheduleId));
		
        return (new Promise((resolve, reject) => {				
				(async () => {
					let doc = firestore.collection('environments/' + env + '/canvas/' + channel + '/toplists/schedules/by-date').doc(String(moment.unix(start).format('YYYY-MM-DD')));

                    console.log('environments/' + env + '/canvas/' + channel + '/toplists/schedules/by-date')


                    let unsubscribe = doc.onSnapshot((snapshot) => {
                        console.log(snapshot);
                        let data = snapshot.data();
                        var transformed = [];
                        console.log(data);
                        for(var type in data){
                            let slots = data[type];

                            for(var slotIdx in slots){
                                for(var idx in slots[slotIdx]){
                                    let item = slots[slotIdx][idx];

                                    //Load Event-Metadata
                                    
                                    transformed.push({
                                        meta: {
                                            id: item.id,
                                            type: type
                                        },
                                        start: item['active-from'].seconds,
                                        end: item['active-to'].seconds,
                                        priority: slotIdx
                                    });
                                }
                            }
                        }

                        transformed = Object.values(_.reject(transformed, (t) => (typeof t === 'undefined' || t.length === 0)));

                        dispatch(receive_schedule(scheduleId, transformed));
                    });

                    dispatch({
                        type: scheduletypes.SET_UNSUBSCRIBE_HANDLER,
                        scheduleId: scheduleId,
                        unsubscribe: unsubscribe
                    });

					resolve();
				})();
			}));
	}
}

export function request_schedule(scheduleId) {  
  return {
    type: scheduletypes.REQUEST_SCHEDULE,
    scheduleId: scheduleId
  };
}

export function receive_schedule(scheduleId, data){
	return  {
		type: scheduletypes.RECEIVE_SCHEDULE,
		schedule: data,
		scheduleId: scheduleId
	}
}

export function save_schedule(firebase, channel, scheduleId, date, data){
	return function(dispatch){
        dispatch({
            type: scheduletypes.UPDATING,
            scheduleId: scheduleId
        });

        let user = firebase.auth().currentUser.uid;

        return (new Promise((resolve, reject) => {				
				(async () => {
                    let firestore = firebase.firestore();

                    let doc = {
                        cmd: 'SCHEDULE',
                        scope: 'toplists',
                        data: {
                            date: moment.unix(date).format('YYYY-MM-DD'),
                            content: data
                        },
                        user: user,
                        created: new Date()
                    };
                    await firestore.collection('environments/' + env + '/canvas/' + channel + '/commands').add(doc);

                    resolve();
                })();
			}));
    }
}

export function load(firestore, channel){
	return function(dispatch){
        return (new Promise((resolve, reject) => {				
				(async () => {
                    let q = firestore.collection('environments/' + env + '/canvas/' + channel + '/toplists/lists/raw');
                    let unsubscribe = q.onSnapshot((snapshot) => {
                        if(snapshot.empty)return;
                        let results = [];
                        
                        snapshot.forEach((doc) => {
                            let data = doc.data();
                            if(typeof data.uid === 'undefined')
                                data.uid = doc.id;
                            results.push(data);
                        });

                        dispatch({
                            type: types.SET_TOPLISTS,
                            toplists: results
                        });
                    });

                    dispatch({
                        type: types.SET_UNSUBSCRIBE_HANDLER,
                        unsubscribe: unsubscribe
                    });
                })();
			}));
    }
}

export function save(firebase, channel, id, data){
	return function(dispatch){
        dispatch({
            type: types.UPDATING,
            toplist: id
        });

        let user = firebase.auth().currentUser.uid;

        return (new Promise((resolve, reject) => {				
				(async () => {
                    let firestore = firebase.firestore();

                    let doc = {
                        cmd: 'UPDATE',
                        scope: 'toplists',
                        data: {
                            id: id,
                            content: data
                        },
                        user: user,
                        created: new Date()
                    };
                    await firestore.collection('environments/' + env + '/canvas/' + channel + '/commands').add(doc);

                    resolve();
                })();
			}));
    }
}

export function set(key, val) {  
  return {
    type: types.SET,
    key: key,
    val: val
  };
}

export function select(id) {  
  return {
    type: types.SELECT,
    toplist:id
  };
}

export function unselect(key) {  
  return {
    type: types.UNSELECT
  };
}

export function edit(id) {  
  return {
    type: types.EDIT,
    toplist: id
  };
}

export function cancel_edit() {  
  return {
    type: types.END_EDIT
  };
}

export function create() {  
  return {
    type: types.CREATE
  };
}
